import { NativeSelect, Select, TextInput } from '@common/components';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { isActiveUserMap, paymentPlanMap, userTypeMap } from 'src/constants/statuses';
import { useTranslation } from 'react-i18next';
import { fetchSiteUsersSearch, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';

import styles from './styles.module.scss';
import { useOs } from '@mantine/hooks';

interface FilterUserListProps {
  onIsActive: (item: boolean) => void;
}

const FilterUserList: FC<FilterUserListProps> = ({ onIsActive }) => {
  const os = useOs();
  const [isActiveUser, setIsActiveUser] = useState<string | null>('all');
  const [paymentPlan, setPaymentPlan] = useState<string | null>('all');
  const [userType, setUserType] = useState<string | null>('all');
  const [isActive, setIsActive] = useState<boolean>(false);
  const [t] = useTranslation('reported');
  const [c] = useTranslation('common');
  const dispatch = useAppDispatch();
  const issues = useAppSelector((state) => state.issues, shallowEqual);

  const handleUserTypeChange = (value: string | null): void => {
    setUserType(value);
    setIsActive(value !== 'all' ? true : false);
    dispatch(fetchSiteUsersSearch({ params: { userType: value === 'all' ? '' : value } }));
  };

  const handlePaymentPlanChange = (value: string | null): void => {
    setPaymentPlan(value);
    setIsActive(value !== 'all' ? true : false);
    dispatch(fetchSiteUsersSearch({ params: { paymentPlan: value === 'all' ? '' : value } }));
  };

  const handleActiveStatusChange = (value: string | null): void => {
    setIsActiveUser(value);
    setIsActive(value !== 'all' ? true : false);
    dispatch(fetchSiteUsersSearch({ params: { active: value === 'all' ? '' : value } }));
  };

  const handleNativeUserTypeChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setUserType(e.currentTarget.value);
    setIsActive(e.currentTarget.value !== 'all' ? true : false);
    dispatch(
      fetchSiteUsersSearch({ params: { userType: e.currentTarget.value === 'all' ? '' : e.currentTarget.value } }),
    );
  };

  const handleNativePaymentPlanChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setPaymentPlan(e.currentTarget.value);
    setIsActive(e.currentTarget.value !== 'all' ? true : false);
    dispatch(
      fetchSiteUsersSearch({ params: { paymentPlan: e.currentTarget.value === 'all' ? '' : e.currentTarget.value } }),
    );
  };

  const handleNativeActiveStatusChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setIsActiveUser(e.currentTarget.value);
    setIsActive(e.currentTarget.value !== 'all' ? true : false);
    dispatch(
      fetchSiteUsersSearch({ params: { active: e.currentTarget.value === 'all' ? '' : e.currentTarget.value } }),
    );
  };

  const handleSearch = (value: string): void => {
    dispatch(fetchSiteUsersSearch({ params: { search: value } }));
    setIsActive(value !== '' ? true : false);
  };

  useEffect(() => {
    onIsActive(isActive);
  }, [isActive]);

  useEffect(() => {
    issues;
  }, [issues]);

  return (
    <div className={styles['filters-list']}>
      <TextInput
        className={styles.search}
        label={`${t('searchUserInput')}`}
        ariaLabel={`${t('searchUserInput')}`}
        placeholder={t('searchUserInput')}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {os === 'ios' || os === 'macos' ? (
        <>
          <NativeSelect
            variant="secondary"
            aria-label={`${c('combobox')}`}
            value={isActiveUser as string}
            data={isActiveUserMap}
            onChange={handleNativeActiveStatusChange}
          />
          <NativeSelect
            variant="secondary"
            aria-label={`${c('combobox')}`}
            value={paymentPlan as string}
            data={paymentPlanMap}
            onChange={handleNativePaymentPlanChange}
          />
          <NativeSelect
            variant="secondary"
            aria-label={`${c('combobox')}`}
            value={userType as string}
            data={userTypeMap}
            onChange={handleNativeUserTypeChange}
          />
        </>
      ) : (
        <>
          <Select
            variant="secondary"
            withIcon
            aria-label={`${c('combobox')}`}
            value={isActiveUser}
            data={isActiveUserMap}
            onChange={handleActiveStatusChange}
          />
          <Select
            variant="secondary"
            sx={{
              '.mantine-Select-dropdown': {
                width: '150px !important',
              },
            }}
            aria-label={`${c('combobox')}`}
            withIcon
            value={paymentPlan}
            data={paymentPlanMap}
            onChange={handlePaymentPlanChange}
          />
          <Select
            variant="secondary"
            sx={{
              '.mantine-Select-dropdown': {
                width: '150px !important',
              },
            }}
            aria-label={`${c('combobox')}`}
            withIcon
            value={userType}
            data={userTypeMap}
            onChange={handleUserTypeChange}
          />
        </>
      )}
    </div>
  );
};

export default FilterUserList;
